import { createSelector } from '@reduxjs/toolkit';

import { selectCompSequence } from '../orderSelectors.ts';
import { selectImprovementsEntities } from '../propertyDataSelectors/improvementsSelectors.ts';

// TODO: No clue why this is necessary, some race condition where comp improvements are populated one by one?
export const selectIsCommentaryLoaded = createSelector(
  [selectImprovementsEntities, selectCompSequence],
  (improvements, compSequence) =>
    ['subject', ...compSequence].every((id) => improvements[id] !== undefined),
);
